// CommonIcon.js
import React from 'react';
import * as Icons from 'lucide-react';
const CommonIcon = ({ iconName, size = 24, color = "black", ...props }) => {
  const IconComponent = Icons[iconName];
  // If the icon doesn't exist in the library, return null or a fallback icon.
  if (!IconComponent) {
    return <Icons.AlertCircle size={size} color="red" {...props} />; // Fallback icon
  }
  return <IconComponent size={size} color={color} {...props} />;
};
export default CommonIcon;